<script lang="ts">
	import { Icons } from '$lib/components/icon'
	import { logout } from '@helpers/settings'
	import { _ } from '@repo/i18n'
	import { DropdownItem } from '@repo/ui'
	import { impersonatedAccount } from '@store/account'
</script>

<div class="text-red-500 dark:text-red-300">
	<DropdownItem
		name="logout"
		disabled={Boolean($impersonatedAccount)}
		icon={Icons.ArrowRightOnRectangle}
		onclick={logout}
		title={$_('user.logout')}
	/>
</div>
